import React from 'react'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'

import {closeMobileMenu, closeMobileMenuAccordions} from '../../actions/mobileMenu'
import {initiateOnboarding} from '../Onboarding/redux/actions'
import {getLoginRedirectPath} from '../Onboarding/standaloneUtils'

const MobileMenuSignin = ({openOnboardingLogin, openOnboardingRegistration}) => (
  <div className="mobile-menu-signin">
    <button className="mobile-menu-register-button" onClick={openOnboardingRegistration}>
      Get Started
    </button>
    <button className="mobile-menu-login-button" onClick={openOnboardingLogin}>
      Login
    </button>
  </div>
)

MobileMenuSignin.propTypes = {
  openOnboardingLogin: PropTypes.func.isRequired,
  openOnboardingRegistration: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => ({
  openOnboardingLogin: () => {
    window.location.href = getLoginRedirectPath()
  },
  openOnboardingRegistration: () => {
    dispatch(initiateOnboarding())
    dispatch(closeMobileMenu())
    dispatch(closeMobileMenuAccordions())
  },
})

export default connect(null, mapDispatchToProps)(MobileMenuSignin)
